<template>
  <div>
    <v-img
      v-if="light"
      class="logo mr-5"
      transition="none"
      :src="'https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Logo.svg?updatedAt=1691473453962'"
      :width="width"
      height="auto"
      contain
      @click="navigate"
    />
    <v-img
      v-else
      class="logo mr-5"
      transition="none"
      :src="'https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Logo.svg?updatedAt=1691473453962'"
      :width="width"
      height="auto"
      contain
      @click="navigate"
    />
  </div>
</template>

<script>

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    name: 'logo',
  props: {
    width: {
      default: 150,
    },
    light: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {};
  },
  computed: {
    ...GlobalComputed,
  },
  methods: {
    navigate() {
            if (this.$route.name === 'home'){
        if (document.documentElement.scrollTop > 50) {
          this.scrollToTop();
        }
      } else {
                this.$router.push({name: 'home'});
      }
    },

    ...GlobalMethods,
  },
};
</script>
<style lang="scss" scoped>
.logo {
  cursor: pointer;
//   position: absolute;
  left: 2.75%;
  right: 76.08%;
  top: 0.12%;
  bottom: 99%;

  background: #ffffff00;
  transition: all 0.2s ease-in;
  &:active {
    // transform: scale(0.95);
    opacity: 0.7;
  }
}
</style>